import types from './types';
import store from '../../../config/redux/store';
import { asyncGet } from '../../../config/rest/async-action-creator';

export default {
  getHomepageData: (customStore) => asyncGet(
    customStore || store,
    types.GET_HOMEPAGE_DATA,
    'homepage',
  ),
};



// WEBPACK FOOTER //
// ./src/app/actions/home/index.js